var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInHouse(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.781,
    height: 18.781,
    viewBox: "0 0 18.781 18.781",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_5564",
    "data-name": "Group 5564",
    transform: "translate(-257.25 -80.25)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_6857",
    "data-name": "Path 6857",
    d: "M17.291,11.932v-.893h1.786L11.039,3,3,11.039H4.786v6.252a1.786,1.786,0,0,0,1.786,1.786H8.806",
    transform: "translate(255 78)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6858",
    "data-name": "Path 6858",
    d: "M9,20.145V14.786A1.786,1.786,0,0,1,10.786,13h1.786a1.786,1.786,0,0,1,1.786,1.786",
    transform: "translate(254.359 76.932)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6859",
    "data-name": "Path 6859",
    d: "M13,21.466l2.68-2.68,1.786,1.786L21.039,17",
    transform: "translate(253.932 76.504)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_6860",
    "data-name": "Path 6860",
    d: "M19,17h2.68v2.68",
    transform: "translate(253.291 76.504)",
    fill: "none",
    stroke: "#758ca1",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInHouse);
export default __webpack_public_path__ + "static/media/in-house.39913996.svg";
export { ForwardRef as ReactComponent };